import type * as Api from 'Api'

export const eventErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
